module.exports = __webpack_public_path__ + "static/nutzer-72e43dbc6f4305d6fa58f17111135d6d.svg";